import { ProcessChain } from "../../icons/index.js";
import {
  MyVsmsParamsSchema,
  defaultMyVsmsParams,
  type MyVsmsParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { MyVsmsWidget } from "./Component.js";
import type { MyVsmsView } from "./types.js";

export const myVsmsDef: SqlWidgetDef<MyVsmsParams, MyVsmsView> = {
  kind: "myVsms",
  label: "My VSMs",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 640, h: 320 },
  defaultParams: defaultMyVsmsParams,
  Component: MyVsmsWidget,
  storage: "sql",
  schema: MyVsmsParamsSchema,
  accent: "pb-tint-4",
  icon: ProcessChain,
  subtitle: "Your value streams",
  defaultRoster: false,
  category: "single",
  layout: { col: 1, row: 1, width: 640, height: 320 },
  dashboard: {
    icon: ProcessChain,
    defaultWidth: "wide",
    category: "Operations",
  },
};

registerWidget(myVsmsDef);
